var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"giveaway-partners section"},[_c('div',{staticClass:"d-none d-md-block fs-lg-120 fs-md-72 lh-lg-134 lh-md-78 ls-4 pb-md-48 pb-sm-32"},[_vm._v("\n    "+_vm._s(_vm.$t('giveaway.header.partners'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"row g-0"},_vm._l((_vm.partners),function(partner,i){return _c('div',{key:partner.name,staticClass:"giveaway-partners__partner col-md-3 col-6 position-relative",class:{
        'giveaway-partners__partner--left-border-desktop': ![0, 4].includes(i),
        'giveaway-partners__partner--left-border-mobile': i % 2 !== 0
      }},[_c('div',{staticClass:"border-top-black h-100",class:{
          'mb-16': i < 4,
          'ml-md-16': ![0, 4].includes(i),
          'mr-md-16': ![3, 7].includes(i),
          'mr-sm-16': i % 2 === 0,
          'ml-sm-16': i % 2 !== 0,
          'border-bottom-md-black': i > 2,
          'border-bottom-sm-black': i > 4
        }},[_c('giveaway-partner',{staticClass:"d-flex justify-content-center align-content-center h-100",attrs:{"name":partner.name}})],1)])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }